import { LoggedInDiscordUser } from "./types";
import router from "./router";
import Axios from "axios";

export default class User {
  public static get(): LoggedInDiscordUser | null {
    const userJson = localStorage.getItem("user");
    if (userJson === null) {
      return null;
    }
    return JSON.parse(userJson);
  }

  public static login() {
    localStorage.setItem("previousRoute", router.currentRoute.path);
    window.open(
      `https://discord.com/api/oauth2/authorize?client_id=769882288279257088&redirect_uri=${encodeURIComponent(
        process.env.VUE_APP_BASE_URI
      )}%2Fredirect%2Fdiscord%2Fevent&response_type=code&scope=identify`,
      "_self"
    );
  }

  public static logout() {
    Axios.defaults.headers.common = {};
    localStorage.removeItem("user");
    router.go(0);
  }

  public static async refresh() {
    const userJson = localStorage.getItem("user");

    if (userJson === null) {
      return;
    }

    const user = JSON.parse(userJson);

    const response = await Axios.patch("/users/discord", {
      refreshToken: user.refreshToken,
    });

    const discordResponse = await this.getDiscordUser(
      response.data.access_token
    );

    user.id = discordResponse.data.id;
    user.username = discordResponse.data.username;
    user.globalName = discordResponse.data.globalName;
    user.discriminator = discordResponse.data.discriminator;
    user.avatar = discordResponse.data.avatar;
    const validUntil = new Date();
    //Just adding 7 days flat to the refresh because Discord started responding with 1h default even though it refreshes 
    //to 7 days.
    validUntil.setSeconds(validUntil.getSeconds() + 60 * 60 * 24 * 7);

    user.accessToken = response.data.access_token;
    user.refreshToken = response.data.refresh_token;
    user.validUntil = validUntil;

    localStorage.setItem("user", JSON.stringify(user));
  }

  public static async getDiscordUser(accessToken: string) {
    return await Axios.get(`${"/users/users"}`, {
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    });
  }

  public static async isModerator(): Promise<boolean> {
    const localUserStorage = localStorage.getItem("user");
    if (localUserStorage === null) {
      return false;
    }

    const localUser = JSON.parse(localUserStorage);

    const response = await this.getDiscordUser(localUser.accessToken);

    return response.data.moderator;
  }
}
